// extracted by mini-css-extract-plugin
export var gif = "_im-0";